module.exports = __webpack_public_path__ + "static/media/close-button.f25311c9.svg";